import React, { useMemo } from 'react'
import { createColumnHelper } from '@tanstack/react-table'
import { DateCell, RawTextCell, TooltipCell } from '@/components/Table/components/Cell'
import { UserStatus } from '.'
import { camelToWords } from '@/utils/stringHelper'
import { FilterType } from '@/components/Table/components/Filter/TableFilter'

export const getUserTableColumns = ({
  adminRoleOptions = [],
  userOptions = [],
  businessUnitOptions = [],
  contributorGroupsOptions = [],
  costCenterOptions = [],
  teamsOptions = [],
}) => {
  const columnHelper = createColumnHelper()

  return [
    columnHelper.accessor('employeeNumber', {
      header: () => <span>Employee No.</span>,
      cell: RawTextCell,
      size: 120,
    }),
    columnHelper.accessor('fullName', {
      size: 180,
    }),
    columnHelper.accessor('initial', {
      cell: RawTextCell,
      size: 100,
    }),
    columnHelper.accessor('businessUnit', {
      size: 100,
      cell: RawTextCell,
      meta: {
        filterVariant: FilterType.SELECT,
        filterOptions: businessUnitOptions,
      },
    }),
    columnHelper.accessor('role', {
      size: 100,

      meta: {
        filterVariant: FilterType.SELECT,
        filterOptions: [
          { label: 'Admin', value: 'admin' },
          { label: 'User', value: 'user' },
        ],
      },
    }),
    columnHelper.accessor('email', {
      cell: RawTextCell,
    }),
    columnHelper.accessor('contributorGroup', {
      meta: {
        filterVariant: FilterType.SELECT,
        filterOptions: contributorGroupsOptions,
      },
    }),
    columnHelper.accessor('technicalLineManager', {
      meta: {
        filterVariant: FilterType.SELECT,
        filterOptions: userOptions,
      },
    }),
    columnHelper.accessor('commercialLineManager', {
      meta: {
        filterVariant: FilterType.SELECT,
        filterOptions: userOptions,
      },
    }),
    columnHelper.accessor('costCenter', {
      cell: RawTextCell,
      meta: {
        filterVariant: FilterType.MULTI_SELECT,
        filterOptions: costCenterOptions,
      },
    }),
    columnHelper.accessor('lastLoginDate', {
      cell: DateCell,
      meta: {
        filterVariant: FilterType.DATE,
      },
    }),
    columnHelper.accessor('status', {
      meta: {
        filterVariant: FilterType.MULTI_SELECT,
        filterOptions: Object.values(UserStatus).map((status) => {
          return {
            label: camelToWords(status),
            value: status,
          }
        }),
      },
    }),
    columnHelper.accessor('adminRoles', {
      cell: ({ getValue }) => {
        if (!Array.isArray(getValue())) {
          return <>-</>
        }

        return (
          <TooltipCell
            text={getValue()
              .map((val) => camelToWords(val))
              .join(', ')}
          />
        )
      },
      meta: {
        filterVariant: FilterType.MULTI_SELECT,
        filterOptions: adminRoleOptions,
      },
    }),
    columnHelper.accessor('teams', {
      cell: RawTextCell,
      meta: {
        filterVariant: FilterType.MULTI_SELECT,
        filterOptions: teamsOptions,
      },
    }),
    columnHelper.accessor('division', {
      cell: RawTextCell,
    }),
    columnHelper.accessor('defaultTeam', {
      cell: RawTextCell,
      meta: {
        filterVariant: FilterType.MULTI_SELECT,
        filterOptions: teamsOptions,
      },
    }),
  ]
}

export default getUserTableColumns
